module.exports = __webpack_public_path__ + "media/a6.c27000a5.wav";